import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import './Navbar.css'

const Header = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [isFixed, setIsFixed] = useState(true);
  const location = useLocation();

  const toggleMenu = () => {
    setIsFixed(true);
    setMenuVisible(!menuVisible);
  };

  const closeMenu = () => {
    setMenuVisible(false);
  };

  // Close menu when route changes
  useEffect(() => {
    closeMenu();
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (menuVisible) return; // Ignore scrolling when menu is open
      setIsFixed(true);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [menuVisible]);

  return (
    <header className={`header ${isFixed ? "fixed" : ""}`}>
      <nav 
        className={`navbar navbar-expand-lg ${isFixed ? "navbar-light bg-white" : "navbar-transparent"}`}
        style={{
          position: 'relative', // Ensure proper positioning
          borderBottom: '4px solid #198754' // Add border instead of absolute positioned line
        }}
      >
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img src={isFixed ? "/logocasaorigen.png" : "/logoecoxata.png"} alt="Logo" className="navbar-logo" style={{ width: '160px' }} />
          </Link>

          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarNav" 
            aria-controls="navbarNav" 
            aria-expanded={menuVisible ? 'true' : 'false'} 
            aria-label="Toggle navigation"
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${menuVisible ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link" onClick={closeMenu}>Inicio</Link>
              </li>
              <li className="nav-item">
                <Link to="/casa_origen" className="nav-link" onClick={closeMenu}>CASA ORIGEN</Link>
              </li>
              <li className="nav-item dropdown">
                <Link 
                  to="#" 
                  className="nav-link dropdown-toggle"
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                >
                  ALOJAMIENTO
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/cabaña_vista_al_mar" className="dropdown-item" onClick={closeMenu}>
                      CABAÑA VISTA AL MAR
                    </Link>
                  </li>
                  <li>
                    <Link to="/cabaña_la_portuguesa" className="dropdown-item" onClick={closeMenu}>
                      CABAÑA LA PORTUGUESA
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link to="/restaurante" className="nav-link" onClick={closeMenu}>RESTAURANTE</Link>
              </li>
              <li className="nav-item">
                <Link to="/granja" className="nav-link" onClick={closeMenu}>GRANJA</Link>
              </li>
              <li className="nav-item dropdown">
                <Link 
                  to="#" 
                  className="nav-link dropdown-toggle"
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                >
                  AVENTURA
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/senderismo" className="dropdown-item" onClick={closeMenu}>
                      SENDERISMO
                    </Link>
                  </li>
                  <li>
                    <Link to="/cabalgata" className="dropdown-item" onClick={closeMenu}>
                      CABALGATA
                    </Link>
                  </li>
                  <li>
                    <Link to="/pesca" className="dropdown-item" onClick={closeMenu}>
                      PESCA
                    </Link>
                  </li>
                  <li>
                    <Link to="/camping" className="dropdown-item" onClick={closeMenu}>
                      CAMPING
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link to="/spa" className="nav-link" onClick={closeMenu}>SPA</Link>
              </li>
              <li className="nav-item">
                <Link to="/contactos" className="nav-link" onClick={closeMenu}>CONTACTOS</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header